import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3153, { U3153ROLES } from './U3153';
import U3153InvoiceTypeList from './components/U3153InvoiceTypeList';
import U3153InvoiceTypeForm from './components/U3153InvoiceTypeForm';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3153Routes: RouteObject[] = [
  {
    path: 'U3153',
    element: <U2000RequireRole allowedRoles={[U3153ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3153 />,
        children: [
          { index: true, element: <U3153InvoiceTypeList /> },
          { path: ':id', element: <U3153InvoiceTypeForm /> },
        ],
      },
    ],
  },
];

export default U3153Routes;
